import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import { Form, Checkbox, Row, Col, Steps, Space, Modal as antmodal, Tooltip, Typography } from 'antd';
import {
  theme,
  CardAnt,
  ButtonAnt,
  Modal,
  Text
} from '@pfmam/pfmam';
import { Container, Box } from '../../styles/globalStyle';
import { AccountInformation } from '../components/accountTitleStepOne';
import { AccountInvestmentOptions } from './accountInvestmentOptionsStepTwo';
import ReviewAccountForm from './reviewAccountDetailsStepFour';
import TeamMembersAccountPermissionsComponent from './teamMembersAccountPermissions';
import { ValidateAccountTitle, GetInvestmentTypes, NewAccountTeamMembers, GetActiveAccountsForClient, SubmitAccountRequest } from '../../actions/actions';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { InfoCircleOutlined } from '@ant-design/icons';
import ReactHtmlParser from 'react-html-parser';

const OverrideStyle = createGlobalStyle`
  .ant-form-item-control-input-content {
    & > span {
      width: 100%;
    }
    .primary.ant-select-single:not(.ant-select-customize-input) {
      .ant-select-selector {
        height: 52px;
        width: 100%;
        background: ${theme.colors.white};
        color: ${theme.colors.black_secondary};
        border: 1px solid ${theme.colors.grey};
        padding: 14px 20px;
        .ant-select-selection-item,
        .ant-select-selection-placeholder {
          line-height: 20px;
        }
        .ant-select-selection-search-input {
          height: 100%;
        }
      }
      .ant-select-arrow .anticon:not(.ant-select-suffix) {
        pointer-events: none;
    }
      .ant-select-arrow {
        font-size: ${theme.font_size.size_l};
        margin-top: 0;
        top: 50%;
        transform: translateY(-50%);
        right: 20px;
      }
      &.ant-select-focused {
        .ant-select-selector {
          box-shadow: ${theme.shadows.input_focus};
          border-color: ${theme.colors.blue_primay};
        }
          .ant-select-arrow {
          color: ${theme.colors.black_secondary};
        }
      } 
    }
  }

  .profile-card .ant-card-head-title {
    font-size: 24px;
    line-height: 32px;
    padding: 24px 0;
  }
    
  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: #f5f5f5;
    border-color:${(props) => props.linkTextColor};
}
  .ant-steps-navigation .ant-steps-item::before {
    background-color: ${(props) => props.linkTextColor};
  }

.ant-checkbox-checked .ant-checkbox-inner {
  background-color: ${(props) => props.linkTextColor};
  border-color:${(props) => props.linkTextColor};
}
  .ant-cascader-checkbox-checked .ant-cascader-checkbox-inner {
    background-color:${(props) => props.linkTextColor};
    border-color:${(props) => props.linkTextColor};
  }
  .form-select-dropdown {
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      .ant-select-item {
        &.ant-select-item-group {
          color: ${theme.colors.grey_tertiary};
          min-height: 16px;
          line-height: 16px;
          padding: 6px 12px;
          &:hover {
            background: none;
          }
        }
      }
      .ant-select-item-option-selected,
      .ant-select-item-option-active {
        &:not(.ant-select-item-option-disabled) {
          background: ${theme.colors.white};
          font-weight: normal;
        }
      }
      .ant-select-item {
        min-height: 40px;
        line-height: 24px;
        padding: 8px 12px;
        font-size: ${theme.font_size.size_xl};
        color: ${theme.colors.black_secondary};
        font-family: 'Inter';
        &:hover {
        background: ${theme.colors.light_grey};
        font-family: 'Inter';
      }
    }
  }
`;
const OverrideButtonAnt = styled(ButtonAnt)`
  &&& {
    background: ${(props) => props.linkTextColor};
    color: white;
  }
`;
const AccountSubmitButtonWrapper = styled(Space)`
  justify-content: center;
  width: 100%;
  min-width: 100%;
  margin-top: 16px;
  .primary {
    width: 160px;
  }
  ${(props) =>
    props.spacing &&
    css`
      margin-top: 48px;
    `}
`;
const Wrapper = styled.div`
  padding: 32px 32px 32px 32px;
`;

export const CreateAccountComponent = (props) => {
  const { primary_color, setIsTouched, isAccountSubmitted, setIsAccountSubmitted } = props;
  const history = useHistory();
  const [form] = Form.useForm();
  const [currentStepnumber, setCurrentStepNumber] = useState(0);
  const [formValues, setFormValues] = useState({
    accTitle: null,
    isAccBonds: null,
    paidDividendsAccountOptions: null,
    additionalAccTitle: null,
    paidDividendsAccount: null,
    mvarIsAccBonds: null,
    accountTeamMembers: null
  }); // Centralized state to store form values

  const [paidDividendsChoice, setPaidDividendsChoice] = useState(null); // State to track the choice of paid dividends
  const clientDetails = useSelector(
    (state) => state.programsClientsSlice.selectedClient
  );
  const programId = clientDetails.payload[0].programid;
  const ssnorTIN = clientDetails.payload[0].ssnortin;
  const connectLoggedInContactId = useSelector((state) => state.userSlice.user.profile.sub);
  const [accountOptions, setAccountOptions] = useState([]);
  const [investmentOptions, setInvestmentOptions] = useState([]);
  const [teamMembersData, setTeamMembersData] = useState([]);
  const [validating, setValidating] = useState(false);
  const [accountTitleMsg, setAccountTitleMsg] = useState('');
  const [accountTitleStatus, setAccountTitleStatus] = useState(null); // 'success' | 'error' | null
  const [isDisclaimerPrimChecked, setIsDisclaimerPrimChecked] = useState(false);
  const [changedMembers, setChangedMembers] = useState([]);
  const [isDisclaimerSecChecked, setIsDisclaimerSecChecked] = useState(false);
  const [AccCheckedPrimaryDisclaimer, setAccCheckedPrimaryDisclaimer] = useState('Upon submitting, I acknowledge that I have full authorization to open Accounts on behalf of the entity. I acknowledge that PFM Asset Management reserves the right to request proof of authority in the form of election certification, board minutes, resolutions, fiduciary trusts agreement, etc. when updating permissions. I understand it is my sole responsibility to promptly notify PFM Asset Management of any changes to authorized Contacts.');
  const [AccPlgitSecCheckedDisclaimer, setAccPlgitSecCheckedDisclaimer] = useState('I agree that with the assignation of Check Verifier: (1) the Investor is responsible for designating check verifiers and reviewing checks presented against the account in accordance with the terms and conditions contained in the Pennsylvania Local Government Investment Trust Information Statement as well as any additional updates that may occur; (2) the Investor shall notify PLGIT Client Services of any checks that should not be paid by 12pm on the business day following the presentment of checks; (3) no action taken by the Investor by 12pm on the business day following the presentment of checks shall be understood as an affirmation that the checks presented should be paid.');
  // Validate titles directly in the parent component
  const validateAccountTitles = async () => {
    setValidating(true);
    try {
      // Get the values
      const accTitle = form.getFieldValue('accTitle');
      const additionalAccTitle = form.getFieldValue('additionalAccTitle');
      // Check if titles are identical
      if (paidDividendsChoice == "Yes" && accTitle && additionalAccTitle && accTitle.trim().toLowerCase() === additionalAccTitle.trim().toLowerCase()) {
        setAccountTitleStatus('error');
        setAccountTitleMsg('Main Account Title and Additional Account Title cannot be the same');
        setValidating(false);
        return false;
      }

      const mainTitleResponse = await ValidateAccountTitle(accTitle, paidDividendsChoice == "Yes" ? additionalAccTitle : null, ssnorTIN);
      if (mainTitleResponse.status !== 200 || mainTitleResponse.data.exists === true && mainTitleResponse.data.additionalAccountTitle === true) {
        setAccountTitleStatus('error');
        setAccountTitleMsg('Account Title and Additional Account Title already exists for this Client. Please choose a different account title.');
        setValidating(false);
        return false;
      }
      if (mainTitleResponse.status !== 200 || mainTitleResponse.data.exists === true && mainTitleResponse.data.additionalAccountTitle === false) {
        setAccountTitleStatus('error')
        setAccountTitleMsg('Account Title already exists for this Client. Please choose a different account title.');
        setValidating(false);
        return false;
      }
      if (mainTitleResponse.status !== 200 || mainTitleResponse.data.additionalAccountTitle === true && mainTitleResponse.data.exists === false) {
        setAccountTitleStatus('error');
        setAccountTitleMsg('Additional Account Title already exists for this Client. Please choose a different account title.');
        setValidating(false);
        return false;
      }
      setValidating(false);
      return true;
    } catch (error) {
      setAccountTitleStatus('error');
      setAccountTitleMsg('Error validating account titles');
      setValidating(false);
      return false;
    }
  };

  useEffect(() => {
    GetActiveAccountsForClient(programId, ssnorTIN).then((response) => {
      if (response.data !== null && response.data.Table.length > 0) {
        setAccountOptions([{ label: "This Account", value: "0" }]);
        const accOptions = response.data.Table.map(item => ({
          label: item.DisplayName,
          value: item.AccountUniqueID,
        }));
        setAccountOptions((prevOptions) => [...prevOptions, ...accOptions]);
      }
    }).catch((error) => {
      handleError("Error fetching active accounts: " + error);
    });

    GetInvestmentTypes(programId).then((response) => {
      if (response.data !== null && response.data.Table.length > 0) {
        const InvestmentOptions = response.data.Table.map(item => ({
          label: item.FundShortName,
          value: item.FundUniqueID,
          type: item.FundType
        }));
        setInvestmentOptions((prevOptions) => [...prevOptions, ...InvestmentOptions]);
      }
    }).catch((error) => {
      console.log(error);
      handleError("Error fetching active accounts: " + error);
    });
    NewAccountTeamMembers(programId, ssnorTIN).then((response) => {
      if (response.data !== null && response.data.Table.length > 0) {
        const updatedTableValues = response.data.Table.map(item => {
          if (item.ContactId == connectLoggedInContactId) {
            return { ...item, IsViewReports: 1, IsManageUsers: 1, IsCloseAccounts: 1 };
          }
          return item;
        });
        setTeamMembersData(updatedTableValues);
        setFormValues((prevValues) => ({
          ...prevValues,
          accountTeamMembers: updatedTableValues,
        }));
      }
    }).catch((error) => {
      handleError("Error fetching account team members:" + error);
    });
  }, []);
  const handleError = (err) => {
    setIsTouched(false);
    console.log(err);
    antmodal.warning({
      title: 'There was an error processing the request. Please try again.',
      okText: 'Ok',
      onOk: () => {
        history.push("/dashboard");
      },
    });
  };
  // Modified handleNext with integrated validation
  const handleNext = async () => {
    try {
      const values = await form.validateFields();
      // For step 0, validate account titles
      if (currentStepnumber === 0) {
        const isValid = await validateAccountTitles();
        if (!isValid) {
          return; // Stop if validation fails
        }
      }
      if (currentStepnumber === 1 && programId === 50) {
        const validateInvestmentoptions = form.getFieldValue('mvarIsAccBonds') || [];
        const selectedIds = Array.isArray(validateInvestmentoptions) ? validateInvestmentoptions.flat() : [];
        const hasMilafMaxClass = selectedIds.some(id => {
          const opt = investmentOptions.find(opt => String(opt.value) === String(id));
          return opt && opt.label === "MILAF+ MAX Class";
        });
        const hasMilafCashClass = selectedIds.some(id => {
          const opt = investmentOptions.find(opt => String(opt.value) === String(id));
          return opt && opt.label === "MILAF+ Cash Mgmt Class";
        });
        if ((hasMilafMaxClass && !hasMilafCashClass) || (!hasMilafMaxClass && hasMilafCashClass)) {
          antmodal.warning({
            title: 'Select both MILAF+ Cash Mgmt Class and MILAF + Max Class to continue.',
            okText: 'Ok',
          });
          return;
        }
      }
       if (currentStepnumber === 1 && programId === 44) {
        const validateInvestmentoptions = form.getFieldValue('mvarIsAccBonds') || [];
        const selectedIds = Array.isArray(validateInvestmentoptions) ? validateInvestmentoptions.flat() : [];
        const hasPlgitClass = selectedIds.some(id => {
          const opt = investmentOptions.find(opt => String(opt.value) === String(id));
          return opt && opt.label === "PLGIT-Class";
        });
        if (!hasPlgitClass) {
          antmodal.warning({
            title: 'Select PLGIT Class to continue',
            okText: 'Ok',
          });
          return;
        }
      }
      if (currentStepnumber === 1 && programId === 53) {
        const validateInvestmentoptions = form.getFieldValue('mvarIsAccBonds') || [];
        const selectedIds = Array.isArray(validateInvestmentoptions) ? validateInvestmentoptions.flat() : [];
        const hasMSDLAFLiquidClass = selectedIds.some(id => {
          const opt = investmentOptions.find(opt => String(opt.value) === String(id));
          return opt && opt.label === "MSDLAF+ Liquid Class";
        });
        const hasMSDLAFMaxClass = selectedIds.some(id => {
          const opt = investmentOptions.find(opt => String(opt.value) === String(id));
          return opt && opt.label === "MSDLAF+ MAX Class";
        });
        if ((hasMSDLAFLiquidClass && !hasMSDLAFMaxClass) || (!hasMSDLAFLiquidClass && hasMSDLAFMaxClass)) {
          antmodal.warning({
            title: 'Select both MSDLAF+ Liquid Class and MSDLAF+ MAX Class to continue.',
            okText: 'Ok',
          });
          return;
        }
      }
      if (currentStepnumber === 1 && programId === 64) {
        const validateInvestmentoptions = form.getFieldValue('mvarIsAccBonds') || [];
        const selectedIds = Array.isArray(validateInvestmentoptions) ? validateInvestmentoptions.flat() : [];
        const hasGovMIC = selectedIds.some(id => {
          const opt = investmentOptions.find(opt => String(opt.value) === String(id));
          return opt && opt.label === "GovMIC";
        });
        const hasMilafCashClass = selectedIds.some(id => {
          const opt = investmentOptions.find(opt => String(opt.value) === String(id));
          return opt && opt.label === "MILAF+ Cash Mgmt Class";
        });
        if (hasMilafCashClass && !hasGovMIC) {
          antmodal.warning({
            title: 'Select GovMIC to continue.',
            okText: 'Ok',
          });
          return;
        }
      }
      if (currentStepnumber === 1) {
        const validateInvestmentoptions = form.getFieldValue('mvarIsAccBonds') || [];
        const selectedIds = Array.isArray(validateInvestmentoptions) ? validateInvestmentoptions.flat() : [];
        const hasTerm = selectedIds.some(id => {
          const opt = investmentOptions.find(opt => String(opt.value) === String(id));
          return opt && opt.type === "Term";
        });
        const hasMoneyMarket = selectedIds.some(id => {
          const opt = investmentOptions.find(opt => String(opt.value) === String(id));
          return opt && opt.type === "Money Market";
        });
        if (hasTerm && !hasMoneyMarket) {
          antmodal.warning({
            title: 'If "Term" is selected, "Money Market" must also be selected.',
            okText: 'Ok',
          });
          return;
        }
      }
      if (currentStepnumber === 2) {
        // Validate that each required permission has at least one assigned user.
        // Check Verifier (PLGIT only) is intentionally excluded and remains optional.
        const teamMembers = formValues.accountTeamMembers || [];
        const requiredPermissions = [
          { key: 'IsViewReports', label: 'View Reports' },
          { key: 'IsEnterTransactions', label: 'Enter Transactions' },
          { key: 'IsModifyBankingInstructions', label: 'Modify Banking Instructions' },
          { key: 'IsCloseAccounts', label: 'Close Accounts' },
          { key: 'IsManageUsers', label: 'Manage Users' },
          { key: 'IsStatementRecipient', label: 'Statement Recipient' },
        ];
        const missingPermissions = requiredPermissions.filter(
          (permission) => !teamMembers.some((member) => member[permission.key])
        );

        if (missingPermissions.length > 0) {
          const missingNames = missingPermissions.map((permission) => permission.label).join(', ');
          antmodal.warning({
            title: 'Required permissions are missing user assignments.',
            content: ReactHtmlParser(`<p>The following required permissions are missing user assignments: <b>${missingNames}</b>.</p></br><p>Assign at least one user to each required permission and select Next.</p>`),
            okText: 'Ok',
          });
          return;
        }

        // Validate Statement Recipient Mail Address
        const invalidRecipients = teamMembers.filter(
          (member) => member.IsStatementRecipient && (!member.MailAddress || member.MailAddress === '')
        );
        const validRecipients = teamMembers.filter(
          (member) => member.MailAddress && member.MailAddress !== ''
        );

        if (invalidRecipients.length > 0) {
          const names = invalidRecipients.map(m => m.DisplayName).join(', ');
          var validNames=""; 
           if (validRecipients.length > 0) {
             validNames = validRecipients.map(m => m.DisplayName).join(', ');
           }

          antmodal.warning({
            title: 'Statement Recipients must have a mail address.',
            content: ReactHtmlParser(`<p>The following user(s) have no statement address on file: <b>${names}</b>.</p></br><p>To proceed, add an address in the Team Members tab of Organizational Settings, or unselect these user(s) and choose from existing recipients list: <b>${validNames}</b>.</p>`),
            okText: 'Ok',
          });
          return;
        }
      }
      // If validation passes, proceed to next step
      var frmValue = form.getFieldsValue();
      setFormValues((prevValues) => ({
        ...prevValues,
        ...frmValue,
      }));

      if (currentStepnumber < 4) {
        setCurrentStepNumber(currentStepnumber + 1);
      }
    } catch (errorInfo) {
      console.log('Failed:', errorInfo);
    }
  };

  const handleBack = async () => {
    try {
      var frmValue = form.getFieldsValue();
      setFormValues((prevValues) => ({
        ...prevValues,
        ...frmValue, // Merge current step values into centralized state
      }));
      if (currentStepnumber > 0) {
        setAccountTitleStatus(null)
        setCurrentStepNumber(currentStepnumber - 1);
      }
    } catch (errorInfo) {
    }
  };
  // Function to render the current step's component
  const renderStepContent = () => {
    switch (currentStepnumber) {
      case 0:
        return (
          <AccountInformation
            form={form}
            ssnorTIN={ssnorTIN}
            accountOptions={accountOptions}
            paidDividendsChoice={paidDividendsChoice}
            setPaidDividendsChoice={setPaidDividendsChoice}
            setFormValues={setFormValues}
            accountTitleMsg={accountTitleMsg}
            accountTitleStatus={accountTitleStatus}
            validating={validating}
          />
        );
      case 1:
        return (
          <AccountInvestmentOptions form={form} investmentOptions={investmentOptions} />
        );
      case 2:
        return (
          <TeamMembersAccountPermissionsComponent
            formValues={formValues}
            setFormValues={setFormValues}
          />
        );
      case 3:
        return (
          <ReviewAccountForm
            programId={programId}
            connectLoggedInContactId={connectLoggedInContactId}
            accountOptions={accountOptions}
            formValues={formValues}
            teamMembersData={teamMembersData}
            investmentOptions={investmentOptions}
            changedMembers={changedMembers}
            setChangedMembers={setChangedMembers}
            setAccountTitleMsg={setAccountTitleMsg}
            setAccountTitleStatus={setAccountTitleStatus}
            setCurrentStepNumber={setCurrentStepNumber}
          />
        );
      default:
        return null;
    }
  };

  const handleSubmit = () => {
    if (programId === 44 && (isDisclaimerPrimChecked === false || isDisclaimerSecChecked === false)) {
      antmodal.warning({
        title: 'Please accept both the disclaimers to proceed.',
        okText: 'Ok'
      });
    }
    else if (programId !== 44 && isDisclaimerPrimChecked === false) {
      antmodal.warning({
        title: 'Please accept the disclaimer to proceed.',
        okText: 'Ok'
      });
    }
    else {
      SubmitAccountRequest(formValues, programId, ssnorTIN).then((response) => {
        if (response.data !== null && response.data === true) {
          setIsAccountSubmitted(true);
        } else {
          handleError("Failed to submit account request.");
        }
      }).catch((error) => {
        handleError("Error submitting account request: " + error);
      });
    }
  };

  const handleConfirmationModalCancel = () => {
    setIsAccountSubmitted(false);
    //navigate to Org settings page.
    history.push("/settings");
  };
  const handleCheckboxChange = (e, type) => {
    if (type === 'AccCheckedPrimaryDisclaimer') {
      setIsDisclaimerPrimChecked(e.target.checked);
    } else if (programId === 44 && type === 'AccPlgitSecCheckedDisclaimer') {
      setIsDisclaimerSecChecked(e.target.checked);
    }
  };
  return (
    <Wrapper>
      <OverrideStyle linkTextColor={primary_color} />
      <Container>
        <CardAnt
          className="profile-card basic-card"
          title={
            <div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <span>New Account Information</span>
              </div>
              {currentStepnumber === 3 && (
                <label type="secondary" style={{ fontSize: 13, display: 'block', marginTop: 4, marginBottom: 8, whiteSpace: 'pre-line' }}>
                  Carefully review the new account details, then click 'Submit' to send for processing.
                </label>
              )}
              {currentStepnumber === 2 && (
                <label style={{ fontSize: 13, display: 'block', marginTop: 4, marginBottom: 8, whiteSpace: 'pre-line' }}>
                  {(paidDividendsChoice == "Yes" ? "Assign appropriate permissions for existing Team Members. Each required permission must be assigned to at least one Team Member. New Team Members and Statement Recipients can be added within the Team Members page under Organizational Settings once the account is open. The selected contacts and their assigned permissions will apply to both new accounts and can be modified at any time after the account is opened."
                    : "Assign appropriate permissions for existing Team Members. Each required permission must be assigned to at least one Team Member. New Team Members and Statement Recipients can be added within the Team Members page under Organizational Settings once the account is open."
                  )}
                </label>
              )}
            </div>
          }
          cardContent={
            <Box minwidth="100%" maxwidth="100%" margin="0 auto">
              <Box
                display="flex"
                minwidth="100%"
                maxwidth="100%"
                flexdirection="column"
                boxcolor={theme.colors.white}>
                <Steps className="site-navigation-steps" type="navigation" current={currentStepnumber} labelPlacement="vertical">
                  <Steps.Step stepNumber={1} title="Account Information" />
                  <Steps.Step stepNumber={2} title="Investment Options" />
                  <Steps.Step stepNumber={3} title="Team Members" />
                  <Steps.Step stepNumber={4} title="Review" />
                </Steps>
              </Box>
              {/* Render Multi Step Content */}
              <Box
                display="flex"
                padding="50px 0 0 0"
                flexdirection="column"
                boxcolor={theme.colors.white}>
                {renderStepContent()}
              </Box>
              {currentStepnumber === 3 ? (
                <>
                  <Row style={{ marginTop: '16px' }}>
                    <Col>
                      <Form.Item>
                        <Checkbox onChange={(e) => handleCheckboxChange(e, 'AccCheckedPrimaryDisclaimer')}>
                          <Text
                            fontSize="16px"
                            lineheight="18px"
                            label={AccCheckedPrimaryDisclaimer}
                          />
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>
                  {programId === 44 && <Row style={{ marginTop: '16px' }}>
                    <Col>
                      <Form.Item>
                        <Checkbox onChange={(e) => handleCheckboxChange(e, 'AccPlgitSecCheckedDisclaimer')}>
                          <Text
                            fontSize="16px"
                            lineheight="18px"
                            label={AccPlgitSecCheckedDisclaimer}
                          />
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>}
                </>
              ) : null}
            </Box>

          }
        />
        <AccountSubmitButtonWrapper size={12}>
          {currentStepnumber === 0 ?
            null :
            <ButtonAnt
              label="Back"
              type="secondary"
              htmlType="button"
              onClick={() => {
                handleBack();
              }}
            />}
          {currentStepnumber === 3 ? (
            <>
              <OverrideButtonAnt
                linkTextColor={props.primary_color}
                label="Submit"
                type="primary"
                onClick={handleSubmit}
                htmlType="submit"
              // disabled={programId === 44 ? !(isDisclaimerPrimChecked && isDisclaimerSecChecked) : !isDisclaimerPrimChecked} // Disable unless checked
              />
            </>
          ) : currentStepnumber === 0 || currentStepnumber === 1 || currentStepnumber === 2 ? <OverrideButtonAnt
            linkTextColor={props.primary_color} label="Next" type="primary"
            onClick={() => {
              handleNext();
            }}
            htmlType="submit"
          /> : null}
        </AccountSubmitButtonWrapper>
      </Container>

      {isAccountSubmitted && (
        <Modal
          title={'Account Request Submitted Successfully.'}
          width={670}
          bodyStyle={{
            padding: '20px 42px 34px 42px',
            fontSize: '17px'
          }}
          maskStyle={{
            backgroundColor: `${theme.rgba.modal}`,
            zIndex: '1051',
          }}
          content={'New Account form has been sent for processing. Please allow up to 48 hours for account to open.'}
          visible={isAccountSubmitted}
          onCancel={handleConfirmationModalCancel}
          footer={
            <>
              <Box display="flex" justifycontent="center">
                <OverrideButtonAnt
                  linkTextColor={primary_color}
                  type="secondary"
                  htmlType="button"
                  label="Ok"
                  onClick={() => history.push("/dashboard")}
                />
              </Box>
            </>
          }
          centered={true}
          closable={true}
          cancelButtonProps={{ style: { display: 'none' } }}
          maskClosable={false}
        />

      )}
    </Wrapper>
  );
};